import type { RouteObject } from 'react-router';

import * as searchVolopsHorizonRouteExports from '#/modules/search/volops/page/SearchVolops.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchVolopsRoutePaths } from './seachVolops.route-paths';

const searchVolopsRouteObject = horizonRouteToObject(
  searchVolopsHorizonRouteExports,
);
const createSearchVolopsRouteObject = (path: string): RouteObject => ({
  path,
  ...searchVolopsRouteObject,
});

export const searchVolopsRouteObjects = searchVolopsRoutePaths.map(
  createSearchVolopsRouteObject,
) satisfies RouteObject[];
